<template>
  <b-modal
    v-bind:visible="value"
    v-on:input="$emit('input')"
    v-bind="$attrs"
    v-on="$listeners"
    @hide="closeModalNotifications"
    body-class="position-static" >
      <template v-slot:default="scope">
        <modal-notifications></modal-notifications>
        <text-overlay :show="saving || deleting" no-wrap :text="saving ? savingText : deletingText" rounded></text-overlay>
        <slot name="default" v-bind="scope"></slot>
      </template>
      <template v-for="slot in Object.keys($scopedSlots).filter(x => !(['default', 'modal-footer'].includes(x)))" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
      <template #modal-footer="{ok, cancel}">
        <delete-button class="mr-auto" v-if="deleteMethod !== null" :disabled="deleteDisabled" @confirmed="deleteClicked().then(() => ok())"/>
        <b-button variant="outline-secondary" :disabled="cancelDisabled" @click="cancelClicked().then(() => cancel())">{{ cancelText }}</b-button>
        <!-- On success, we close the modal and on error we don't because usually there is some modal notification. To close, we call ok() in the first param and nothing in the second -->
        <b-button variant="primary" :class="saveDisabled ? 'save-disabled' : ''" :disabled="saveDisabled" @click="saveClicked().then(() => ok(), () => {})">{{ saveText }}</b-button>
      </template>
  </b-modal>
</template>

<script>
  import ModalNotifications from '../ModalNotifications'
  import { BModal, BOverlay, BButton } from 'bootstrap-vue'
  import * as types from '../../store/mutation-types'
  import TextOverlay from '../TextOverlay.vue'
  import DeleteButton from '../DeleteButton'

  export default {

    data() {
      return {
        saving: false,
        deleting: false
      }
    },

    props: {
      value: {
        type: Boolean,
        required: false,
        default: false
      },
      // Make sure your function returns a promise that can be chained, otherwise confusing behavior may result
      save: {
        required: false,
        default: null
      },
      saveDisabled: {
        type: Boolean,
        required: false,
        default: false
      },
      saveText: {
        type: String,
        required: false,
        default: 'Save'
      },
      savingText: {
        type: String,
        required: false,
        default: ''
      },
      // Make sure your function returns a promise that can be chained, otherwise confusing behavior may result
      cancelMethod: {
        required: false,
        default: null
      },
      cancelDisabled: {
        type: Boolean,
        required: false,
        default: false
      },
      cancelText: {
        type: String,
        required: false,
        default: 'Cancel'
      },
      // Make sure your function returns a promise that can be chained, otherwise confusing behavior may result
      // Optional delete functionality
      deleteMethod: {
        required: false,
        default: null
      },
      deleteDisabled: {
        type: Boolean,
        required: false,
        default: false
      },
      deletingText: {
        type: String,
        required: false,
        default: ''
      },
    },

    methods: {
      saveClicked() {
        if (this.save === null){
          return Promise.resolve();
        };
        this.saving = true;
        let self = this;
        // We make sure to throw the exception on error so that the modal won't close
        return this.save().then(() => {
          self.saving = false;
        }).catch((exception) => {self.saving = false; throw exception});
      },
      cancelClicked() {
        if (this.cancelMethod === null){
          return Promise.resolve();
        };
        return this.cancelMethod();
      },
      deleteClicked() {
        this.deleting = true;
        let self = this;
        return this.deleteMethod().then(() => {
          self.deleting = false;
        }).catch(() => {self.deleting = false});
      },
      closeModalNotifications () {
        this.$store.commit(types.HIDE_ALL_MODAL_NOTIFICATIONS);
        this.$emit('hide');
        this.saving = false;
        this.deleting = false;
        this.$emit('input', false);
      },
    },

    components: {
      ModalNotifications,
      BModal,
      BOverlay,
      TextOverlay,
      DeleteButton,
      BButton
    },
  }
</script>

<style scoped>
  .save-disabled {
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// XmModal.vue?1a4ef8e6